import { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

// Components
import DropDownRegularInput from "../../UI/FormInput/DropDownRegularInput";

// Images
import icnId from './Images/icn-id.png';
import icnInfo from './Images/icn-info.png';
import icnContract from './Images/icn-contract.png';
import icnImportant from './Images/icn-important.png';

// Store
import { getDropDownOptions } from "../../../store/options/options.actions";

// Utilities
import { formatDropDownOptions } from "../../../utilities/helper-functions";

// Styles
import './Styles.scss';

export default function WelcomeCard() {

    const [product, setProduct] = useState('');

    const dropDownOptions = useSelector((state) => state.options.dropDownOptions);

    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(getDropDownOptions());

    }, [dispatch]);

    const options = [

        ...(dropDownOptions?.data?.currentAccountProducts ?? []),

        ...(dropDownOptions?.data?.savingAccountProducts ?? []),

        ...(dropDownOptions?.data?.foreignCurrencyAccountProducts ?? [])

    ];

    const selectedProduct = options.find(
        (option) => option.value === product
    );

    const getRequirementIcon = (id) => {

        switch (id) {

            case 1:
            case 5:
                return icnId;

            case 2:
                return icnInfo;

            case 3:
                return icnContract;

            case 4:
                return icnImportant;

            default:
                return icnImportant;

        }

    };

    return (

        <div className="user-access-welcome">

            <h1>Bienvenido a <span>Bancaribe</span></h1>

            <h2>Abre tu cuenta fácil y rápido</h2>

            {dropDownOptions?.isLoading ? (
                <div>Cargando...</div>
            ) : (
                <div>
                    <p className="user-access-welcome-text"><strong>Conoce los tipos de cuenta que tenemos para ti y sus requisitos:</strong></p>

                    <DropDownRegularInput
                        value={product}
                        onChange={setProduct}
                        options={formatDropDownOptions(options)}
                    />
                </div>
            )}

            {[...(selectedProduct?.requirements ?? [])]
                .sort((a, b) => a.order - b.order)
                .map((requirement) => (

                    <WelcomeInstruction
                        key={requirement.id}
                        icon={getRequirementIcon(requirement.id)}
                        title={requirement.title}
                        message={
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: requirement.description
                                }}
                            />
                        }
                    />

                ))}

        </div>

    );

}

const WelcomeInstruction = ({ icon, title, message }) => (

    <div className="welcome-instruction">

        <div className="welcome-instruction-title">

            <div>
                <img src={icon} alt={title} />
            </div>

            <p>{title}</p>

        </div>

        <div className="welcome-instruction-message">
            {message}
        </div>

    </div>

);